import { render } from "./HeaderNotificationsComponent.vue?vue&type=template&id=5437a6f1&scoped=true"
import script from "./HeaderNotificationsComponent.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationsComponent.vue?vue&type=script&lang=js"

import "./HeaderNotificationsComponent.vue?vue&type=style&index=0&id=5437a6f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5437a6f1"]])

export default __exports__